"use client"

import { useState } from "react"
import Header from "../../components/protected/Header"
import ReactPaginate from "react-paginate"
import Footer from "../../components/footer"
import Words from "../../components/protected/words/Words"
import { useTranslations } from "../../translations";

const WordsSent = ({ values }) => {
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage] = useState(6)
  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const paginate = ({ selected }) => {
    setCurrentPage(selected + 1)
  }
  const currentItems = values.data.slice(indexOfFirstItem, indexOfLastItem)
  const { t } = useTranslations()

  return (
    <div className="dashboard-wrapper">
      <Header />
      <main className="dashboard-main-content">
        <div className="d-flex justify-content-between align-items-center mb-5">
          <div>
            <h1 className="dashboard-title mb-1">{values.title}</h1>
            <p className="text-muted">{t("manageSentWords")}</p>
          </div>
        </div>

        <div className="modern-card">
          <h4 className="fw-bold color-plum mb-4">{t("words")}</h4>
          
          <div className="table-responsive">
            <table className="table modern-table">
              <thead>
                <tr>
                  <th scope="col" className="text-center">#</th>
                  <th scope="col">{t("spanish")}</th>
                  <th scope="col" className="text-center">{t("syllables")}</th>
                  <th scope="col">{t("english")}</th>
                  <th scope="col">{t("topic")}</th>
                  <th scope="col">{t("sentTo")}</th>
                  <th scope="col" className="text-center">{t("details")}</th>
                </tr>
              </thead>
              <tbody>
                {currentItems && (
                  <Words
                    currentItems={currentItems}
                    itemOffset={indexOfFirstItem}
                    handleImage={values.handleImage}
                    isModule={values.isModule}
                  />
                )}
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-center mt-5">
            <ReactPaginate
              onPageChange={paginate}
              pageCount={Math.ceil(values.data.length / itemsPerPage)}
              previousLabel={t("previous")}
              nextLabel={t("next")}
              containerClassName={"modern-pagination"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
            />
          </div>
        </div>
        <Footer logged={values.logged} />
      </main>

      <style>{`
        .color-plum { color: var(--plum-bg); }
      `}</style>
    </div>
  )
}

export default WordsSent
